import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/authSlice';
import profileReducer from './features/profileSlice';
import rulesRegulationsReducer from './features/rulesRegulationsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    rulesRegulations: rulesRegulationsReducer,
  },
});
